import React, { Component, useState, useEffect } from "react";
import { styled, useTheme } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import PersonIcon from '@mui/icons-material/Person';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

import { UserInfo, netGet, netPost, netFetch, keycloak } from "../network";

function UsersDeleteDialog(props) {
    const {
        title = 'Delete Mobility Users',
        open,
        onSave,
        onCancel,
        users=[],
        ...other
    } = props;



    const onOKClick = () => {
        if ( typeof onSave === 'function' ) {
            onSave(users);
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };



    return (
        <Dialog
            maxWidth={'1000px'}
            open={open}
            disableRestoreFocus
            onClose={onClose}
            slotProps ={{
                paper: {
                    sx: {
                    minWidth: 600,
                    maxHeight: 700
                    }
                }
              }}
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent>
                <Box sx={{height: '200px', overflow: 'auto'}}>
                    <List dense={true}>
                        {users.map( (user,index) =>
                            <ListItem>
                                <ListItemIcon>
                                    <PersonIcon />
                                </ListItemIcon>
                                <ListItemText
                                    primary={user.userName}
                                    secondary={user.email}
                                    slotProps={{
                                        root: {
                                            sx: {
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                pr: '2rem',
                                                pl: '1rem',
                                            }
                                        },
                                        primary: {
                                            sx: { pr: 1}
                                        }
                                    }}
                                />
                            </ListItem>
                        )}
                    </List>
                </Box>
                

               
                
                <Box sx={{paddingTop: '5ex'}}>
                    <Typography sx={{display: 'inline', fontWeight: 'bold'}}>Delete users?</Typography>
                </Box>
                
            </DialogContent>
            <DialogActions>
                <Button onClick={onOKClick} sx={{minWidth: '7em'}} color="error" autoFocus >Delete</Button>
                <Button onClick={onCancelClick} sx={{minWidth: '7em'}}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}

function MobileUsers (props) {
    const {
        readOnly=false,
        ...other
    } = props;

    const [users, setUsers] = useState([]); // user results
    const [searchText, setSearchText] = useState('');
    const [clearEnabled, setClearEnabled] = useState(false);
    const [selected, setSelected] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searching, setSearching] = useState(false);
    const [deleteEnabled, setDeleteEnabled] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [noResults, setNoResults] = useState(false);
    const [statusOpen, setStatusOpen] = useState(false);
    const [statusMessage, setStatusMessage] = useState('');
    const [statusSeverity, setStatusSeverity] = useState('success');
    const [deletedUsers, setDeletedUsers] = useState([]);

    const handleRowClick = (user, index) => {
        const id = `${user.id}-${user.deviceId}`;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setDeleteEnabled(newSelected.length > 0);
        setSelected(newSelected);
    };

    const onSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = users.map((n) => `${n.id}-${n.deviceId}`);
            setSelected(newSelected);
            setDeleteEnabled(newSelected.length > 0);
            return;
        }
        setSelected([]);
        setDeleteEnabled(false);
    };

  

    const onSearchChange = (event) => {
        setSearchText(event.target.value);
        setClearEnabled(typeof event.target.value === 'string' && event.target.value !== '');
    };

    const onClearClick = () => {
        setSearchText('');
        setClearEnabled(false);
        setUsers([]);
        setSelected([]);
        setDeleteEnabled(false);
        setNoResults(false);
    };

    const handleSearchClick = () => {
        if (typeof searchText === 'string' && searchText !== '') {
            setSearching(true);
            setNoResults(false);
            const url = '/api/edocs/user/search?pat=' + encodeURIComponent(searchText) + "&nodups=true";
            // console.log('URL: ' + url);
            netGet(url)
                .then(response => response.json())
                .then(result => {
                    setUsers(result);
                    setPage(0);
                    // console.log('Response: ' + result);
                    setSearching(false);
                    setSelected([]);
                    setDeleteEnabled(false);
                    if (!Array.isArray(result) || result.length === 0) {
                        setNoResults(true);
                    }
                }).catch(error => {
                    console.log('Error fetching search result: ' + error);
                    setSearching(false);
                    setSelected([]);
                    setDeleteEnabled(false);
                    setUsers([]);
                    setPage(0);
                    setNoResults(true);
                });
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleDeleteUserAction = () => {
        const dusers = [];
        users.forEach( u => {
            const k = `${u.id}-${u.deviceId}`;
            if ( selected.includes(k) ) {
                dusers.push(u);
            }
        })
        setSelectedUsers(dusers);
        setDeleteDialogOpen(true);
    };

    const handleDeleteDialogSave = (dusers) => {
        setDeleteDialogOpen(false);
        setSearching(true);
        const demails = dusers.map( u => u.email);
        netPost('/api/edocs/user/del', demails)
            .then(resp => resp.json())
            .then(result => {
                console.log('Delete users: ' + JSON.stringify(result));
                setStatusSeverity('success');
                // const label = result.reduce((total, email) => total.length > 0 ? total + '\n' + email : email)
                // setStatusMessage(`Deleted Users:\n${label}`);
                setDeletedUsers(result);
                setStatusOpen(true);
                handleSearchClick();
            }).catch(error => {
                console.log('Error fetching search result: ' + error);
                setSearching(false);
            });
    };

    const handleDeleteDialogClose = () => {
        setDeleteDialogOpen(false);
    }

    const handleStatusClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setStatusOpen(false);
        // setStatusMessage('');
        // setStatusSeverity('success');
    };

    return (
        <Box sx={{ padding: 1, paddingLeft: 3, display: 'grid', gridTemplateRows: 'min-content min-content 1fr min-content', height: '100%' }}>
            <Box sx={{ paddingTop: 2, paddingBottom: 3 }}>
                <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>Mobility Users</Typography>
            </Box>

            <Box sx={{margin: 3, marginBottom: 5, display: 'flex', justifyContent: 'center'}}>
                <Paper
                    component="form"
                    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: '60%' }}
                >
                    <InputBase
                        value={searchText}
                        onChange={onSearchChange}
                        onKeyDown={(ev) => {
                            // console.log(`Pressed keyCode ${ev.key}`);
                            if (ev.key === 'Enter') {
                                ev.preventDefault();
                                handleSearchClick();
                            }
                        }}
                        sx={{ ml: 1, flex: 1 }}
                        placeholder="Search Mobility Users"
                        inputProps={{ 'aria-label': 'search mobility users' }}
                    />
                    <IconButton color="primary" sx={{ p: '10px' }} aria-label="directions"  disabled={!clearEnabled} onClick={onClearClick} >
                        <ClearIcon />
                    </IconButton>
                    <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                    <Box sx={{display: 'inline-block', textAlign: 'center', width: '2.5rem'}}>
                        {searching ?
                            <Box sx={{display: 'inline-block', p: '10px', paddingTop: '8px', paddingBottom: '8px'}}>
                                <CircularProgress size="1.15rem"/>
                            </Box> :
                            <IconButton color="primary"  type="button" sx={{ p: '10px' }} aria-label="search"  disabled={!clearEnabled} onClick={handleSearchClick} >
                                <SearchIcon />
                            </IconButton>
                        }
                    </Box>
                </Paper>
            </Box>

            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650, }} size="small" aria-label="mobile users table">
                    <TableHead>
                        <TableRow sx={{ fontWeight: 'bold', fontSize: '95%' }}>
                            <TableCell padding="checkbox">
                                <Checkbox
                                    color="primary"
                                    indeterminate={selected?.length > 0 && selected?.length < users.length}
                                    checked={users.length > 0 && selected?.length === users.length}
                                    onChange={onSelectAllClick}
                                    slotProps={{
                                        input: {
                                        'aria-label': 'select all users',
                                        }
                                    }}
                                />
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'inherit', fontSize: 'inherit' }}>User ID</TableCell>
                            <TableCell sx={{ fontWeight: 'inherit', fontSize: 'inherit' }}>First Name</TableCell>
                            <TableCell sx={{ fontWeight: 'inherit', fontSize: 'inherit' }}>Last Name</TableCell>
                            <TableCell sx={{ fontWeight: 'inherit', fontSize: 'inherit' }}>Email</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {noResults ?
                            <TableRow
                                key="nr-0"
                                sx={{ '&:last-child th': { border: 0 } }} >
                                <TableCell colSpan={5}>
                                    No results
                                </TableCell>
                            </TableRow> :
                            <React.Fragment>
                                {
                                    Array.isArray(users) &&
                                    users
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((user, index) => {
                                            const key = `${user.id}-${user.deviceId}`;
                                            const isItemSelected = selected.includes(key);
                                            const labelId = `users-table-checkbox-${index}`;
                                            return (
                                                <TableRow
                                                    onClick={() => handleRowClick(user, index)}
                                                    key={key}
                                                    sx={{ '&:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell padding="checkbox">
                                                        <Checkbox
                                                            color="primary"
                                                            checked={isItemSelected}
                                                            slotProps={{
                                                                input: {
                                                                    'aria-labelledby': labelId,
                                                                }
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell>{user.userName}</TableCell>
                                                    <TableCell>{user.firstName}</TableCell>
                                                    <TableCell>{user.lastName}</TableCell>
                                                    <TableCell>{user.email}</TableCell>
                                                </TableRow>
                                            )
                                        }
                                        )
                                }
                            </React.Fragment>
                        }
                    </TableBody>
                </Table>
            </TableContainer>

            <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <Box>
                    <Tooltip title="Delete selected Mobility users">
                        <Button variant="outlined" startIcon={<DeleteIcon fontSize="inherit" color={deleteEnabled && !readOnly ? "error" : "gray"} />} disabled={!deleteEnabled || readOnly}
                            onClick={handleDeleteUserAction}
                            sx={{ p: 1, paddingTop: '4px', paddingBottom: '4px' }}>
                            Delete
                        </Button>
                    </Tooltip>
                </Box>
                <TablePagination
                    rowsPerPageOptions={[10, 20, 30]}
                    component="div"
                    count={users.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                <UsersDeleteDialog open={deleteDialogOpen} users={selectedUsers} onSave={handleDeleteDialogSave} onCancel={handleDeleteDialogClose} />
                <Snackbar open={statusOpen} autoHideDuration={5000} onClose={handleStatusClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} >
                    <Alert
                        onClose={handleStatusClose}
                        severity={statusSeverity}

                        sx={{ width: '100%' }}
                    >
                        <Box sx={{ height: '150px', overflow: 'auto' }}>
                            <Typography>Deleted users:</Typography>
                            <List dense={true}>
                                {deletedUsers.map((user) =>
                                    <ListItem>
                                         <ListItemText
                                            primary={user}
                                            
                                        />
                                    </ListItem>
                                )}
                            </List>
                        </Box>
                    </Alert>
                </Snackbar>
            </Box>
                    
            {/*
            <Box sx={{ paddingTop: 2, paddingLeft: 0 }}>
                <Tooltip title={ADD_LABEL} >
                    <IconButton color="success" onClick={handleAddSelectionClick} disabled={readOnly}>
                        <AddBoxIcon fontSize="inherit" />
                    </IconButton>
                </Tooltip>
                <Tooltip title={MOD_LABEL} >
                    <IconButton color="primary" onClick={handleModifySelectionClick} disabled={readOnly || !deleteActionEnabled}>
                        <EditIcon fontSize="inherit" />
                    </IconButton>
                </Tooltip>
                <Tooltip title={DELETE_LABEL}>
                    <IconButton disabled={!deleteActionEnabled} onClick={handleDeleteSelectionClick} color="error">
                        <DeleteIcon fontSize="inherit" />
                    </IconButton>
                </Tooltip>
                <CreateDefinitionDialog open={createDialogOpen} onCancel={() => setCreateDialogOpen(false)} onSave={handleCreateDialogSave} />
                <CreateDefinitionDialog open={editDialogOpen} onCancel={() => setEditDialogOpen(false)} onSave={handleModifyDialogSave} edit={true} 
                    value={definitions[selectedIndex]} title="Edit Workflow Definition"/>
                <DeleteDefinitionDialog open={deleteDialogOpen} onCancel={() => setDeleteDialogOpen(false)} varName={definitions[selectedIndex]?.name} onSave={handleDeleteDialogSave} />
                <Snackbar open={statusOpen} autoHideDuration={3000} onClose={handleStatusClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} >
                    <Alert
                        onClose={handleStatusClose}
                        severity={statusSeverity}

                        sx={{ width: '100%' }}
                    >
                        {statusMessage}
                    </Alert>
                </Snackbar>
            </Box>
            */}
        </Box>
    );
}

export { MobileUsers, };
